import Button from '@womcorp/wom-miwom-ui-kit/dist/components/Button';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #553e65;
  border-radius: 8px;

  span {
    width: 280px;
  }
  button {
    margin-top: 24px;
    width: 280px;
  }
  strong {
    font-weight: 600;
  }
  img {
    margin: 20px;
  }
  p {
    color: #381451;
    font-size: 20px;
    font-weight: 600;
    padding-bottom: 8px;

    & > span {
      color: #494c66;
      font-weight: 700;
      font-size: 18px;
      line-height: 20px;
    }
  }
`;

const GeneralContainer = styled.div`
  display: grid;
  background-color: #fff;
  border-radius: 8px;
  padding: 24px 0;
  max-width: 279px;

  @media (min-width: 769px) {
    padding: 0;
  }
`;

const IconStyled = styled.div`
  margin-bottom: 16px;
  background-color: #e2e6ea;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  display: grid;
  justify-content: center;
  align-items: center;
`;

const ButtonStyled = styled(Button)`
  max-width: 180px;
`;

export { Container, IconStyled, GeneralContainer, ButtonStyled };
